export const JA = {
  "Open document": "ãã­ã¥ã¡ã³ããéã",
  "Upload file": "ãã¡ã¤ã«ãã¢ããã­ã¼ããã",
  "Drop file here to upload": "ããã«ãã¡ã¤ã«ããã­ãããã¦ã¢ããã­ã¼ããã¾ã",
  "Disc": "ãã£ã¹ã¯",
  "URL": "URL",
  "FILE": "ãã¡ã¤ã«",
  "SIZE": "ãµã¤ãº",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "ãã¤ã",
  "Loading... Please wait.": "èª­ã¿è¾¼ã¿ä¸­ãããå¾ã£ã¦ä¸ããã",
  "Fit Width": "ãã£ããå¹",
  "Fit Height": "ãã£ããã®é«ã",
  "Password protected document": "ãã¹ã¯ã¼ãã§ä¿è­·ããããã­ã¥ã¡ã³ã",
  "Password": "ãã¹ã¯ã¼ã",
  "Open": "éãã",
  "Password Required": "ãã¹ã¯ã¼ããå¿è¦",
  "Incorrect password": "ãã¹ã¯ã¼ããæ­£ããããã¾ãã",
  "Error": "ã¨ã©ã¼",
  "Something went wrong": "ä½ãããã¾ããããªãã£ã",
  "Server is not available": "ãµã¼ãã¼ã¯å©ç¨ã§ãã¾ãã",
  "of": "ã®",
  "Please wait...": "ãå¾ã¡ãã ãã..."
};
